import * as React from "react";

import { Link } from "react-router-dom";

import victoriaLogoMark from "@/assets/logo-mark.svg";
import victoriaLogo from "@/assets/logo.svg";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar";

import { NavMain } from "./nav-main";
import { NavUser } from "./nav-user";
import { TenantSwitcher } from "./tenant-switcher";

export function AppSidebar(props: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <Link
          to="/"
          aria-label="Victoria"
          className="flex h-10 items-center justify-start px-2 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0"
        >
          <img
            src={victoriaLogo}
            alt="Victoria"
            className="h-5 w-auto group-data-[collapsible=icon]:hidden"
          />
          <img
            src={victoriaLogoMark}
            alt=""
            aria-hidden="true"
            className="hidden h-6 w-auto group-data-[collapsible=icon]:block"
          />
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
      <SidebarFooter>
        <TenantSwitcher />
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
